import { render } from "./Date.vue?vue&type=template&id=9f1b768e&bindings={\"date\":\"props\",\"remdays\":\"options\"}"
import script from "./Date.vue?vue&type=script&lang=js"
export * from "./Date.vue?vue&type=script&lang=js"

import "./Date.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script